module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charlene Sands\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Charlene Sands is a USA Today bestselling author of 35 contemporary and historical romances. She's been honored with The National Readers' Choice Award, Booksellers Best Award and Cataromance Reviewer's Choice Award. She loves babies,chocolate and thrilling love stories.Take a peek at her bold, sexy heroes and"), _c('I', [_vm._v(" real good men!")]), _vm._v("  "), _c('a', {
    attrs: {
      "href": "http://www.charlenesands.com"
    }
  }, [_vm._v("www.charlenesands.com")]), _vm._v("  and Facebook")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2XUP19/tc-custom/9781488011931.jpg?1725275644749",
      "alt": "This image is the cover for the book Texan Takes a Wife, Texas Cattleman's Club: Blackmail"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Texan Takes a Wife, Texas Cattleman's Club: Blackmail\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("USA Today")]), _vm._v("–Bestselling Author: It was just supposed to be a temporary tryst with a sexy Texan . . .")]), _c('br'), _c('br'), _vm._v("All it takes is a daring out-of-character ride on a mechanical bull to send Erin Sinclair straight into the arms of one fine-looking cowboy. With Royal, Texas, on edge over the criminal targeting their secrets, she needs to blow off steam. Dan Hunt is happy to give the ex-nanny the time of her life, but the rich rancher insists he doesn’t do relationships."), _c('br'), _c('br'), _vm._v("And Erin’s fine with that—though she can’t help the stirring in her heart as she discovers Dan’s penchant for rescuing animals. But with Erin leaving Royal in a matter of weeks, it can only be a no-strings affair. Even if it feels like it could be the commitment of a lifetime . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0